<template>
  <div class="onlinelanding">
    <b-container fluid>
      <b-row class="mycontainer-main ">
        <b-col cols="12" md="4" class="pl-5 leftcontent">
          <h6 class="my-0" style="color: grey"> Beauté Intégrale </h6>
          <h1> {{ $t('onlineconsultation.jumbo_title') }} </h1>
          <h1 class="pageSubtitle"> {{ $t('onlineconsultation.jumbo_desc1') }} </h1>
          <h1 class="pageSubtitle"> {{ $t('onlineconsultation.jumbo_desc2') }} </h1>
          <b-button squared variant="outline-dark" class="mt-3 shadow" @click="goBack"> {{ $t('common.goback') }}
          </b-button>
          <!-- <b-button squared variant="outline-light" style="background-color: black; min-width: 175px;" class="mt-3 shadow" href="https://moncoachbeaute.ca/products/consultation-privee"> {{ $t('common.request-consultation') }} </b-button>  -->
          <appt-button v-bind:color="'d'" />
        </b-col>

        <b-col cols="12" md="7" class="py-3 centercontent">
          <div class="row car">
            <b-col>
              <b-carousel id="carousel-no-animation" style="text-shadow: 0px 0px 2px #000" no-animation indicators
                img-width="1024" img-height="480">
                <b-carousel-slide :img-src="getImgUrl('staff/Roxanne.jpg')"></b-carousel-slide>
                <b-carousel-slide :img-src="getImgUrl('carpic_1.png')"></b-carousel-slide>
                
              </b-carousel>
            </b-col>
          </div>
          <!-- <div class="p-3 mb-2 centercontent" :style="{ backgroundImage:  'linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.3)), url(' + this.img + ')' ,}"> -->

          <b-card-group deck>
            <b-card class="shadow my-3" style="min-width: 15rem;">
              <b-card-title style="font-weight: bold;"> {{ $t('onlineconsultation.step1') }} </b-card-title>
              <b-card-text class="small text-muted"> {{ $t('common.step1') }} </b-card-text>
              <b-card-text> {{ $t('onlineconsultation.step1_desc') }}</b-card-text>
            </b-card>
            <b-card class="shadow my-3" style="min-width: 15rem;">
              <b-card-title style="font-weight: bold;"> {{ $t('onlineconsultation.step2') }} </b-card-title>
              <b-card-text class="small text-muted">{{ $t('common.step2') }}</b-card-text>
              <b-card-text> {{ $t('onlineconsultation.step2_desc') }} </b-card-text>
            </b-card>
            <b-card class="shadow my-3" style="min-width: 15rem;">
              <b-card-title style="font-weight: bold;"> {{ $t('onlineconsultation.step3') }} </b-card-title>
              <b-card-text class="small text-muted">{{ $t('common.step3') }}</b-card-text>
              <b-card-text> {{ $t('onlineconsultation.step3_desc') }} </b-card-text>
            </b-card>
          </b-card-group>



          <b-card style="background-color: black; color: white; " text-variant="white" class="shadow">
            <b-card-title style="font-weight: bold;"> {{ $t('onlineconsultation.cta') }} </b-card-title>
            <b-button squared variant="outline-light" size="md" class="shadow" to="/appointment/">{{
            $t('main-screen.online_consultation.button_text') }} </b-button>
          </b-card>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>


export default {
  name: 'onlinelanding',
  data() {
    return {
      img: ''
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getImgUrl(pic) {
      return require('../assets/images/' + pic)
    },
  },
  mounted() {

    this.img = require('../assets/images/o_consultation1.jpg')
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mycontainer-main {
  min-height: calc(90vh);
}

.leftcontent {
  padding-top: 30vh;
  padding-bottom: 10vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.centercontent {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.card-img-top {
  width: 100%;
  height: 15rem;
  object-fit: cover;
}

/* .card { 
    background-color: rgba(245, 245, 245, 0.0); 
    color: white;

} */
.scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.scrolling-wrapper-flexbox .card {
  flex: 0 0 auto;
  min-height: 10vh;
}

.scrolling-wrapper-flexbox {
  -webkit-overflow-scrolling: touch;
}

.scrolling-wrapper {
  &::-webkit-scrollbar {
    display: none;
  }
}

.test {
  min-height: 20vh;
  min-width: 10vw;
}

@media screen and (max-width: 600px) {
  .leftcontent {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/OnlineLanding.vue